export const mapInvoiceType = (type) => {
  if (!type) return '';
  const t = type.toLowerCase();
  if (t === 'proforma invoice') return 'PI';
  if (t === 'tax invoice') return 'TI';
  return type;
};
